import styled from 'styled-components';
import { Select, Button, Modal, DatePicker, Icon, Switch } from 'antd';
import {
  UnderlineLink, DisplayFlex, PillButton, PrimaryIndicator, SecondaryButtonComponent
} from "../../../CommonComponents/commonStyles";
const { RangePicker } = DatePicker;

export const PrimaryIndicatorDocument = styled(PrimaryIndicator)`
width: 44px;
height: 18px;
margin-left: 22px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 126px;
}
`
export const GridCheckBoxFileNameWrapper = styled.div`
display: flex;
margin-bottom: 5px;
`
export const DocumentDate = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.13;
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  font-size:${props => props.theme.fontSize.primary};
}
`
export const ListViewDate = styled(DocumentDate)`
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 0px;
}
`
export const GridDate = styled(DocumentDate)`
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-bottom: 5px;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-bottom: 5px;
}
`
export const DocCentreContentWrapper = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
 font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color:  ${props => props.theme.fontColors.textColor};
  margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
  margin-right: ${props => (props.marginRight === undefined) ? "0px" : props.marginRight}

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 1.57;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: 10px;
    margin-left:${props => (props.mlMobile === undefined) ? "0px" : props.mlMobile}
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-bottom: 10px;
  margin-left:${props => (props.mlMobile === undefined) ? "0px" : props.mlMobile}
}
  @media only screen and (min-width: 1024px) and (max-width: 1439px) {
    margin-left: ${props => (props.ml === undefined) ? "0px" : props.ml}
  }
`;

export const Border = styled.div`
border-bottom:solid 1px #d4d4d4;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-right: 0px;
}
`
export const SeparatorBorder = styled.div`
border-right: solid 1px #bfbfbf;
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
margin-right: ${props => (props.marginRight === undefined) ? "0px" : props.marginRight}
height: ${props => (props.height === undefined) ? "0px" : props.height}
`;

export const FlexBorderRight = styled(SeparatorBorder)`
margin-top: ${props => (props.marginTop === undefined) ? "0px" : props.marginTop}
height: 100%;
margin-left: 40px;
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  margin-left: 40px;
}
`;

export const FlexBorderRightDownloadAll = styled(FlexBorderRight)`
height: 40px;
margin-left: 0px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  border-right: none;
}
`

export const SelectTab = styled(Select)`
width: 200px;
.ant-select-selection{
  border-radius : 0px;
}

.ant-select-arrow {
  color: #606060;
  width: 40px;
  height: 100%;
  top: 6px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d4d4d4;
  background: #f5f5f5;
}
.ant-select-selection--multiple{
  min-height: 40px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-bottom: 30px;
  width: 100%;
}
@media only screen and (min-width: 728px) and (max-width: 1023px) {
  margin-bottom: 30px;
}
@media only screen and (min-width: 1023px) and (max-width: 1439px) {
   width: 170px;
}
`;

export const ViewButtons = styled(Button)`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.secondary};
width: 55px;
height: 26px;
border-radius: 13px;
border: solid 1px #006778;
color: ${props => (props.fontColor === 'white') ? "#ffffff" : "#006778"};
background-color:${props => (props.bgColor === 'white') ? "#ffffff" : "#006778"};
`;

export const ViewButtonsWrapper = styled.div`
display: flex; 
align-items: center;
margin-top: 4px;

.ant-switch-small::after{
  width: 22px;
  height: 21px;
}
.ant-switch-small {
  min-width: 50px;
  height: 25px;
}
.ant-switch{
  background-color: #006778;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
  height:27px;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
  height:27px;
}
@media only screen and (min-width: 1024px) and (max-width: 1443px) {
.ant-switch-small::after{
  width: 22px;
  height: 22px;
}
.ant-switch-small {
  min-width: 50px;
  height: 25px;
}
}
`
export const AccordionHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    font-weight: ${props => props.theme.fontWeight.w500};
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`

export const TimeFrame = styled.div`
width:200px;
height:40px;
border-radius:0px;
border: 1px solid #d4d4d4;
line-height:40px;
padding-left:20px;
background:white;
font-size: ${props => props.theme.fontSize.secondary};
font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
color:#d4d4d4`
  ;

export const ClearTime = styled.div`
  position: relative;
  float: left;
  max-width: 100%;
    line-height: 30px;
    height: 30px;
    margin: 4px 2px;
  padding: 0 10px 0 10px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  cursor: default;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  `;

export const PickTimeFrame = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  margin-top: 30px;
  width: 100%;
  text-align: center;
  color: ${props => props.theme.fontColors.headingColor};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
`;

export const CustomModal = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    justify-content: center;
  }
  .ant-modal-footer > * {
    width: 200px;
  }
  .ant-calendar-picker-container{
    left: 0px !important;
    z-index: 1000;
    }
`;

export const CustomDatePicker = styled(RangePicker)`
top:15px;
.ant-calendar-picker-container {
  left: 453px;
  top: 440px;
  .activityMobileWrapper .ant-calendar {
    width: 260px;
  }
}
.ant-calendar-range {
  left: -20px;
}
.ant-calendar-range {
  left: -20px;
}
& .ant-calendar-date-input-wrap {
  margin-left: 100px !important;
}
`;

export const DateWrapper = styled.div`
display: flex;
justify-content: center;
position: relative;
background: white:
width: 500px;
height: 330px;
& > div:first-of-type {
  position: static !important;
}
`;

export const GridViewComponentWrapper = styled.div`
width: 280px;
height: 127px;
box-shadow: 0 9px 21px 0 rgba(128, 152, 213, 0.08);
background-color: #f2f2f2;
margin-right: 20px;
margin-bottom: 20px;
}
@media (min-width: 1200px){
&&& .ant-col-xl-5 {
    width: 22.833333% !important;
}
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  height: 105px;
  margin-right: 0px;
  width: 100%;
}
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  width: 240px;
}
`
export const FlexSpaceBetween = styled(DisplayFlex)`
justify-content: space-between;
`

export const GridViewContentWrapper = styled.div`
padding: 20px;
`
export const GridViewDocumentName = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  margin-bottom: ${props => (props.marginBottom === undefined) ? "0px" : props.marginBottom}
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  width: 230px;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    margin-bottom: 5px;
    }
    @media only screen and (min-width: 1024px) and (max-width: 1439px) {
     width: 170px
      }
`
export const DownloadLinkWrpper = styled.div`
display: flex;
justify-content: space-between;
margin-top: 20px;
margin-bottom: 40px;
@media only screen and (min-width: 320px) and (max-width: 374px) {
  justify-content: normal;
  margin-bottom: 10px;
}
@media only screen and (min-width: 375px) and (max-width: 767px) {
  margin-bottom: 10px;
  justify-content: normal;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  justify-content: normal;
}
`
export const TotalDocuments = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.tertiary};
margin-left: 15px;
width: ${props => (props.width === undefined || props.width === "") ? "43px" : props.width}
height: 20px;
border-radius: 10px;
background-color: #006778;
color: #ffffff;
text-align: center;
padding-top: 1px;
@media only screen and (min-width: 375px) and (max-width: 767px) {
  margin-left: 5px;
  width: ${props => (props.mwidth === undefined || props.mwidth === "") ? "43px" : props.mwidth}
}
@media only screen and (min-width: 320px) and (max-width: 374px) {
  margin-left: 5px;
  width: ${props => (props.mwidth === undefined || props.mwidth === "") ? "30px" : props.mwidth}
}
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  margin-left: 5px;
}
`

export const DownloadAllModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-header {
      padding: 15px 30px 15px 30px;
      background: #fff; 
      border-radius: unset;
      border-bottom: none;
      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
    }
    .ant-modal-footer {
      padding: 16px 20px;
      display: flex;
      justify-content: center;
      border-top: none;
      border-radius: 0 0 4px 4px;
    }
  }
  
`;

export const DocCentreFilterWrapper = styled.div`
margin-top: 30px
margin-bottom: 50px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-top: 20px;
  margin-bottom: 0px;
}
`
export const DownArrow = styled.img`
fill: #006778;
padding-left: 10px;
`
export const DocCentrePillButton = styled(PillButton)`
color: ${props => props.theme.fontColors.primary};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 25px;
  margin-bottom: 10px;
}
`
export const AccordionWrapper = styled.div`
margin-top: ${props => (props.marginTop) ? props.marginTop : ""};
margin-bottom:  ${props => (props.marginBottom) ? props.marginBottom : ""};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-top: 20px;
  margin-bottom: 20px;
}
`
export const AccordionHeaderWrapper = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 10px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  display: block;
  margin-right: 0;
}
  `
export const CheckboxMargin = styled.div`
.ant-form-item{
  margin-bottom: 0px;
  margin-top: ${props => (props.marginTop === undefined) ? "0px" : props.marginTop}
}
.ant-checkbox-inner{
  border: none;
}
.ant-form-item-control{
  line-height: 21px;
}
.ant-checkbox{
  border: 1px solid #b6bdbd;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 0px;
}
`
export const ListCheckboxMargin = styled(CheckboxMargin)`
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .ant-form-item{
  margin-top: 0px;
  }
}
`
export const AccordionCheckboxMargin = styled.div`
.ant-form-item{
  margin-bottom: 0px;
}
.ant-checkbox-inner{
  border: none;
}
.ant-form-item-control{
  line-height: 21px;
}
.ant-checkbox{
  border: 1px solid #b6bdbd;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .ant-form-item{
    margin-left: 0px;
  }
}
`
export const ListAccCheckboxMargin = styled(AccordionCheckboxMargin)`
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .ant-form-item{
    margin-bottom: 0px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .ant-form-item{
    margin-bottom: 0px;
    margin-top: 0px;
  }
}
`
export const GridAccCheckboxMargin = styled(AccordionCheckboxMargin)`
.ant-form-item-control{
  line-height: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .ant-form-item{
    margin-bottom: 0px;
  }
}
`
export const PagesHeading = styled.h1`
font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
font-size: ${props => props.theme.fontSize.h1};
font-weight: ${props => props.theme.fontWeight.normal};
font-style: normal;
color: ${props => props.theme.fontColors.headingColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.bold};
}
`
export const DownloadAllWrapper = styled.div`
display: flex;
align-items: center;
`

export const DownloadSelected = styled.div`
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-top: 20px;
}
  `

export const SpaceBetween = styled.div`
display: flex;
justify-content: space-between;
`

export const SpaceAround = styled.div`
display: flex;
justify-content: space-around;
`

export const FlexEnd = styled.div`
display: flex;
justify-content: flex-end;
`
export const DocCentreWrapper = styled.div`
margin-left: 140px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 23px;
  margin-right: 22px;
}
`

export const ContentContainer = styled.div`
padding: 0.75rem 9% 0 9%;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  padding: 0.5% 6.1% 0 6.1%;
}
  `;

export const DocumentCentreHeading = styled.div`
font-family: ${props => props.theme.fontFamily.berkeleyStd};
font-size: ${props => props.theme.fontSize.h1};
line-height: ${props => props.theme.lineHeight.h1};
letter-spacing:  ${props => props.theme.letterSpacing.normal};
margin-bottom: 30px;
color: ${props => props.theme.fontColors.headingColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  line-height: ${props => props.theme.lineHeight.h2};
}
`
export const DocumentUnderlineLink = styled(UnderlineLink)`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
@media only screen and (min-width: 375px) and (max-width: 767px) {
  margin-left: 0px;
  font-size: ${props => props.theme.fontSize.secondary};
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-left: 0px;
}
`
export const DownloadAllUnderLineLink = styled(DocumentUnderlineLink)`
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
@media only screen and (min-width: 320px) and (max-width: 374px) {
  margin-left: 0;
  font-size: ${props => props.theme.fontSize.tertiary};
}
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  margin-left: 0px;
}
`
export const GridViewUnderlineLink = styled(DocumentUnderlineLink)`
line-height: 1.5;
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  font-size: ${props => props.theme.fontSize.primary};
}
`;

export const GridViewUnderlineAnchor = styled.a`
line-height: 1.5;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 20px;
  font-size: ${props => props.theme.fontSize.secondary};
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-left: 20px;
  font-size: ${props => props.theme.fontSize.primary};
}
`

export const ListViewUnderlineLink = styled(DocumentUnderlineLink)`
width: 100%;
white-space: nowrap;
overflow: hidden;
display: inline-block;
text-overflow: ellipsis;
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`
export const DocCentreUnderlineLink = styled(UnderlineLink)`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
width: 240px;
white-space: nowrap; 
overflow: hidden;
text-overflow: ellipsis;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 0px;
  font-size: ${props => props.theme.fontSize.secondary};
}
`
export const GridViewMainWrapper = styled.div`
@media (min-width: 992px){
&&& .ant-col-lg-6 {
  width: 32% !important; 
}
}
@media (min-width: 1200px){
&&& .ant-col-xl-5 {
    width: 25% !important;
}
}
`
export const ShowDataButton = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.secondary};
  width: ${props => props.width};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const ModalContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.5;
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
text-align: center;
`

export const DocumentCenterContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.5;
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
margin-left: 37px;
margin-bottom: ${props => (props.marginBottom === undefined) ? "0px" : props.marginBottom}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  margin-left: 30px;
}
`
export const ListMobileWrapper = styled.div`
@media only screen and (min-width: 320px) and (max-width: 767px) {
margin-bottom: 20px;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-bottom: 20px;
  }
`

export const MobileListContainer = styled.div`
position: relative;
width: 100%;
`

export const DownnloadIcon = styled(Icon)`
margin-left: 80px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 50px;
  margin-top: 5px;
  float: right;
}
@media only screen and (min-width: 1024px) and (max-width: 1439px) {
  margin-left: 30px;
  margin-top: 5px;
  float: right;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  margin-left: 0;
  margin-top: 5px;
  float: right;
  margin-left: 50px;
}
`

export const FlexCenter = styled(DisplayFlex)`
align-items: center;
margin-left:  ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
margin-bottom: ${props => (props.marginBottom === undefined) ? "0px" : props.marginBottom}
`

export const DocumentOptionsWrapper = styled.div`
display: flex;
align-items: center;
`
export const ListComponentWrapper = styled.div`
display: flex;
align-items: center;
margin-bottom: 30px;
}
`

export const MainListWrapper = styled.div`
:nth-child(odd) .listClassEven{
  border-right: solid 1px #bfbfbf;
  padding-right: 45px;
  }

:nth-last-child(2) .listClassEven{
  border-right: solid 1px #bfbfbf;
  height: 30px;
}

:nth-child(odd) .listClassOdd{
  border-right: solid 1px #bfbfbf;
  }

:nth-last-child(0) .listClassOdd{
  margin-bottom: 30px;
  border-right: solid 1px #bfbfbf;
  height: 30px;
  }
`

export const ListBorder = styled.div`
background: red;
border-right: solid 1px #bfbfbf;
`;

export const ListContent = styled.div`
display: ${props => props.display}
width: ${props => props.width}
`;

export const PlaceHolder = styled.div`
margin-left: 9px;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: #d4d4d4;
@media only screen and (min-width: 320px) and (max-width: 767px) {
 font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const DownloadAllDisabledLink = styled.div`
margin-left:  ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
color: ${props => props.theme.fontColors.textColor};
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};

@media only screen and (min-width: 320px) and (max-width: 767px) {
 font-size:${props => props.theme.fontSize.secondary};
}
`

export const AccountIdWrapper = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.h4};
color: ${props => props.theme.fontColors.textColor};
margin-bottom: 30px;
max-width: 170px;
overflow: hidden;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size:${props => props.theme.fontSize.h5};
 }
`
export const FundNameWrapper = styled.h1`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom: 0px;
  word-break: break-word;
  @media only screen and (max-width:767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`
export const FundNameWrapperContainer = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
`
export const FlexDownloadSelected = styled.div`
display: flex;
align-items: center;
margin-left: ${props => (props.marginLeft === undefined) ? "0px" : props.marginLeft}
@media only screen and (min-width: 320px) and (max-width: 374px) {
  margin-left: 34px;
  }
@media only screen and (min-width: 375px) and (max-width: 767px) {
margin-left: 34px;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  margin-left: 34px;
  }
`

export const RangePickerflex = styled.div`
display: flex; 
justify-content: center;
`

export const MultiSelectWrapper = styled.div`
.ant-select-selection: hover{
  border: 1px solid #d4d4d4 !important ;
}
.ant-select-open .ant-select-selection{
  border: 1px solid #d4d4d4 !important ;
}
.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
  border: 1px solid #d4d4d4 !important ;
  box-shadow: none;
}
.ant-select-selection--multiple .ant-select-selection__choice{
  width: 120px;
  @media only screen and (max-width:767px){
    max-width: 220px;
    width: auto;
  }
}
.ant-select-dropdown {
  border: 1px solid #d4d4d4;
  border-top: none;
  border-radius: 0;
  box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
  top: 41px !important;
  
  li {
    border: none;
    background-color: #ffffff;
    padding: 5px 20px;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
  }
  li:hover {
    color: #167f91;
    background-color: #e6f7ff;
  }
  li:nth-child(-n+2) > i{
    display: none;
  }
  li:nth-child(2){
    margin-top: 5px;
    box-sizing: border-box;
   border-bottom: 1px solid #d4d4d4;
   margin-bottom: 5px;
   padding-bottom: 10px;
  }
}

.ant-select-dropdown:after {
  bottom: 0;
}
`

export const ListViewMargin = styled.div`
margin-top: 30px;
margin-bottom: 30px;
`
export const EmptyMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
  }
`;

export const Toggle = styled(Switch)`
  background-color: ${props => props.theme.colors.primaryColor} !important;
  width: 100px;
  height: 26px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  font-size: ${props => props.theme.fontSize.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  &::after {
    content: '${props => (props.viewButtonValue ? 'Grid' : 'List')}';
    width: 56px !important;
    height: 20px;
    top: 2px;
    color: ${props => props.theme.colors.primaryColor};
    font-stretch: condensed;
  }
  .ant-switch-inner{
    margin-right: ${props => (props.viewButtonValue ? '0px' : '50px')};
    margin-left: ${props => (props.viewButtonValue ? '50px' : '0px')};
    font-size: ${props => props.theme.fontSize.secondary};
    opacity: 0.5;
  }
`;